// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconBrandChrome,
    IconHorse,
    IconGoGame,
    IconShirtSport,
    IconCards,
    IconDashboard,
    IconDeviceAnalytics,
    IconMoneybag,
    IconSpeakerphone
} from '@tabler/icons-react';

import HorseIcon from 'assets/images/menu-icons/racing-icon.svg';
import CasinoIcon from 'assets/images/menu-icons/casino-icon.svg';
import BingoIcon from 'assets/images/menu-icons/bingo-icon.svg';
import SportsIcon from 'assets/images/menu-icons/sports-icon.svg';
import LotteryIcon from 'assets/images/menu-icons/lottery-icon.svg';
import PromotionsIcon from 'assets/images/menu-icons/promotions-icon.svg';
import LiveSupport from 'assets/images/menu-icons/livesupport.svg';
import LiveEvent from 'assets/images/menu-icons/liveevent.svg';
import Sponsorship from 'assets/images/menu-icons/sponsorships.svg';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconBrandChrome,
    IconHorse,
    IconGoGame,
    IconShirtSport,
    IconCards,
    IconDashboard,
    IconDeviceAnalytics,
    IconMoneybag,
    IconSpeakerphone
};
const homePage: NavItemType[] = [
    {
        id: 'dashboard',
        // title: <FormattedMessage id="dashboard" />,
        icon: icons.IconDashboard,
        type: 'group',
        children: [
            {
                id: 'racing-page',
                title: <FormattedMessage id="Racing" />,
                type: 'item',
                url: '/home-page',
                svg: HorseIcon,
                breadcrumbs: false
            },
            {
                id: 'Casino',
                title: <FormattedMessage id="Casino" />,
                type: 'item',
                url: '#',
                svg: CasinoIcon,
                breadcrumbs: false
            },
            {
                id: 'bingo-page',
                title: <FormattedMessage id="Bingo" />,
                type: 'item',
                url: '#',
                svg: BingoIcon,
                breadcrumbs: false
            },
            {
                id: 'sports-page',
                title: <FormattedMessage id="Sports" />,
                type: 'item',
                url: '#',
                svg: SportsIcon,
                breadcrumbs: false
            },
            {
                id: 'lottery-page',
                title: <FormattedMessage id="Lottery" />,
                type: 'item',
                url: '#',
                svg: LotteryIcon,
                breadcrumbs: false
            },
            {
                id: 'promotions-page',
                title: <FormattedMessage id="Promotions" />,
                type: 'item',
                url: '#',
                svg: PromotionsIcon,
                breadcrumbs: false
            },
            {
                id: 'tote',
                title: <FormattedMessage id="tote" />,
                type: 'item',
                url: '#',
                svg: CasinoIcon,
                breadcrumbs: false
            },
            {
                id: 'fixed',
                title: <FormattedMessage id="fixed" />,
                type: 'item',
                url: '#',
                svg: BingoIcon,
                breadcrumbs: false
            },
            {
                id: 'xo',
                title: <FormattedMessage id="xo" />,
                type: 'item',
                url: '#',
                svg: SportsIcon,
                breadcrumbs: false
            },
            {
                id: 'boxing',
                title: <FormattedMessage id="boxing" />,
                type: 'item',
                url: '#',
                svg: LotteryIcon,
                breadcrumbs: false
            },
            {
                id: 'moto',
                title: <FormattedMessage id="moto" />,
                type: 'item',
                url: '#',
                svg: PromotionsIcon,
                breadcrumbs: false
            },
            {
                id: 'discount',
                title: <FormattedMessage id="discount" />,
                type: 'item',
                url: '#',
                svg: Sponsorship,
                breadcrumbs: false
            },
            {
                id: 'live-events',
                title: <FormattedMessage id="live-events" />,
                type: 'item',
                url: '#',
                svg: LiveEvent,
                breadcrumbs: false
            },
            {
                id: 'live-support',
                title: <FormattedMessage id="live-support" />,
                type: 'item',
                url: '#',
                svg: LiveSupport,
                breadcrumbs: false
            }
        ]
    }
];

export default homePage;
